import type { ToteEngagementMode } from '@mote/api'
import { Block, Text } from '@mote/ui'
import { useToteCardContext } from '../ToteCardProvider'
import { ACTION_DATA } from '../helpers'
import type { ToteEngagementModeWithAwaiting } from '../types'
import type { ResponseStyledProps } from './Tesponse.styles'
import { Response, ResponseText } from './Tesponse.styles'

export interface TesponseProps extends Omit<ResponseStyledProps, 'mode'> {
  tesponse: string | null
  mode: ToteEngagementModeWithAwaiting
}

export function Tesponse(props: TesponseProps): JSX.Element {
  const toteCardContext = useToteCardContext()

  return (
    <Response
      transparent={props.transparent}
      mode={props.mode as ToteEngagementMode}
      align={props.tesponse ? undefined : 'center'}
    >
      <Block layout='horizontal' gap={4} align='center'>
        <Text
          tag='small'
          color='currentColor'
          {...toteCardContext.config.actionTextStyles}
        >
          {ACTION_DATA[props.mode].text}
        </Text>
      </Block>
      {props.tesponse ? <ResponseText>{props.tesponse}</ResponseText> : null}
    </Response>
  )
}
